
import React, { useState } from 'react';
import { providers } from '../../../mocks/providers';

export const ProvidersSection: React.FC = () => {
  const [expandedProvider, setExpandedProvider] = useState<number | null>(null);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-rose-100 text-rose-700 rounded-full text-sm font-medium mb-4">
            Провайдеры игр
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Лучшие провайдеры для <span className="text-rose-600">мобильных казино онлайн</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Детальные обзоры ведущих разработчиков игр для онлайн казино России
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {providers.map((provider) => (
            <div
              key={provider.id}
              className={`bg-white rounded-2xl border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-xl ${
                expandedProvider === provider.id ? 'shadow-xl ring-2 ring-rose-200' : 'shadow-md'
              }`}
            >
              <div 
                className="p-6 cursor-pointer"
                onClick={() => setExpandedProvider(expandedProvider === provider.id ? null : provider.id)}
              >
                <div className="flex items-start gap-4">
                  <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 bg-gray-100">
                    <img 
                      src={provider.logo} 
                      alt={provider.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-lg font-bold text-gray-900">{provider.name}</h3>
                      <div className="flex items-center gap-1 bg-amber-50 px-2 py-1 rounded-lg">
                        <i className="ri-star-fill text-amber-500 text-sm"></i>
                        <span className="text-sm font-semibold text-amber-700">{provider.rating}</span>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-2 mb-3">
                      <span className="px-2 py-1 bg-gray-100 rounded-md text-xs text-gray-600">
                        {provider.games} игр
                      </span>
                      <span className="px-2 py-1 bg-emerald-50 rounded-md text-xs text-emerald-700">
                        RTP {provider.avgRTP}
                      </span>
                      <span className="px-2 py-1 bg-sky-50 rounded-md text-xs text-sky-700">
                        {provider.headquarters}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 line-clamp-2">{provider.description}</p>
                  </div>
                  <div className="flex-shrink-0">
                    <i className={`ri-arrow-down-s-line text-xl text-gray-400 transition-transform duration-300 ${
                      expandedProvider === provider.id ? 'rotate-180' : ''
                    }`}></i>
                  </div>
                </div>
              </div>

              <div className={`overflow-hidden transition-all duration-300 ${
                expandedProvider === provider.id ? 'max-h-96' : 'max-h-0'
              }`}>
                <div className="px-6 pb-6 border-t border-gray-100 pt-4">
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Популярные игры</h4>
                      <ul className="space-y-1">
                        {provider.popularGames.map((game, idx) => (
                          <li key={idx} className="text-sm text-gray-600 flex items-center gap-2">
                            <i className="ri-gamepad-line text-rose-500"></i>
                            {game}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Особенности</h4>
                      <ul className="space-y-1">
                        {provider.features.map((feature, idx) => (
                          <li key={idx} className="text-sm text-gray-600 flex items-center gap-2">
                            <i className="ri-check-line text-emerald-500"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <span className="text-sm text-gray-500">Основано: {provider.founded}</span>
                    <button className="px-4 py-2 bg-rose-600 text-white rounded-lg text-sm font-medium hover:bg-rose-700 transition-colors cursor-pointer whitespace-nowrap">
                      Казино с {provider.name}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
